import React from "react";
const Footer = () => {
  return (

    <footer id="footer">

    <div class="container d-md-flex py-4">
      <div class="me-md-auto text-center text-md-start">
        <div class="copyright">
          &copy; Copyright <strong><span>2022</span></strong>. All Rights Reserved
        </div>
        <div class="credits">
        Designed by <a href="javascript:void(0)">Hiren Gohel</a>
        </div>
      </div>
      <div class="social-links text-center text-md-end pt-3 pt-md-0">
      <a href="https://www.facebook.com/progresssolutions13/" class="facebook" target="_blank"><i class="bx bxl-facebook"></i></a>
        <a href="https://www.instagram.com/progresssolution/" class="instagram" target="_blank"><i class="bx bxl-instagram"></i></a>
        <a href="https://in.linkedin.com/in/dharmesh-gohel-11387718" class="linkedin" target="_blank"><i class="bx bxl-linkedin"></i></a>
      </div>
    </div>
  </footer>

  
  );
};

export default Footer;
